angular.module("avant.customer_applications.directives").directive "singleFieldFocus", [
  '$timeout',
  '$window',
  ($timeout, $window) ->
    restrict: 'A'
    scope:
      singleFieldFocus: "@"
      singleFieldFocusInput: "@"
    link: ($scope, element, attrs) ->

      $scope.element = element

      $scope.focusIfActiveConfig = (section_config) ->
        if section_config.section is $scope.singleFieldFocus
          input = _.first($scope.element.find($scope.singleFieldFocusInput))
          if input? && !/(iPhone|iPod|Android|playbook|silk|BlackBerry|BB10|Windows Phone|Tizen|Bada|webOS|IEMobile|Opera Mini)/i.test($window.navigator.userAgent)
            $timeout ->
              input.focus()
            , 200

      $scope.$on "new_active_section_config", (event, section_config) ->
        $scope.focusIfActiveConfig(section_config)

]
